import * as React from 'react';
import SimpleMDEReact from "react-simplemde-editor";
import * as SimpleMDE from "easymde";
import "easymde/dist/easymde.min.css";
import "./MarkdownInput.css"

export interface IMarkdownInputProps {
    textValue: string;
    onChange?(value: string): void
}

export interface IMarkdownInputState {
    textValue: string
}

export default class MarkdownInput extends React.Component<IMarkdownInputProps, IMarkdownInputState> {
  
  constructor(props: any) {
    super(props);

    this.state = {
            textValue: props.textValue.replace('<sup>', '').replace('</sup>', ''),
        };
    }

    handleChange = (value: string) => {
        this.setState({
        textValue: value
        });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    render() {
    
        return (
            <div className="container container-narrow-input">
            <SimpleMDEReact
                className={""}
                label=""
                value={this.state.textValue}
                onChange={this.handleChange}
                options={{
                    autofocus: false,
                    spellChecker: false,
                    status: false,
                    toolbar:
                    [
                        {
                            name: "bold",
                            action: SimpleMDE.toggleBold,
                            className: "fa fa-bold",
                            title: "Bold",
                        },
                        {
                            name: "custom",
                            action: function customFunction(editor){

                                var cm:any = editor.codemirror;
                                cm.replaceSelection("®");
                        
                            },
                            className: "fa fa-registered",
                            title: "Registered Trademark",
                        },
                        {
                            name: "custom",
                            action: function customFunction(editor){

                                var cm:any = editor.codemirror;
                                cm.replaceSelection("™");
                        
                            },
                            className: "fa fa-trademark",
                            title: "Trademark",
                        },
                        "|"
                    ],
                }}
            />
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MarkdownInput/MarkdownInput.tsx